import { render, staticRenderFns } from "./SingleColVideo.vue?vue&type=template&id=1ccb07a3"
import script from "./SingleColVideo.vue?vue&type=script&lang=js"
export * from "./SingleColVideo.vue?vue&type=script&lang=js"
import style0 from "./SingleColVideo.vue?vue&type=style&index=0&id=1ccb07a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports